module.exports = __webpack_public_path__ + "static/media/all_legislation_orange.a6bc82aa.svg";